import { render, staticRenderFns } from "./PosMode.vue?vue&type=template&id=23bbbb30&scoped=true"
import script from "./PosMode.vue?vue&type=script&lang=js"
export * from "./PosMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bbbb30",
  null
  
)

export default component.exports